import { appItem } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900">
              手机看片
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              {appItem.description}
            </p>
            <div className="mt-6 flex flex-wrap justify-center lg:justify-start gap-3">
              <a
                href="#hero"
                onClick={(e) => { e.preventDefault(); document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-bookmark-fill"></i>
                收藏到桌面
              </a>
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-primary-300 text-primary-600 font-semibold text-sm hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill"></i>
                立即观影
              </a>
            </div>
          </div>
          <div className="flex-1 flex justify-center">
            <div className="relative max-w-xs">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-300/30 via-accent-300/20 to-secondary-300/20 rounded-[3rem] blur-2xl"></div>
              <img
                src={appItem.image}
                alt="51影院手机看片"
                title="51影院 - 手机看片更自由"
                className="relative w-60 md:w-72 h-auto rounded-3xl"
                loading="lazy"
                onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}